import React from 'react';

interface SurfaceProps {
  color?: string;
  className?: string;
  children: React.ReactNode;
}

export default function Surface({ color = 'bg-gray-subtle', children, className = '' }: SurfaceProps) {
  return <div className={`rounded-4 px-6 py-8 ${color} ${className}`}>{children}</div>;
}
